<template>
<div>
    <div class="title-box">
        <a href="/" class="back-btn">返回首页</a>
        <div class="title">订单确认页</div>
        <div class="blank-div"></div>
    </div>
    <div class="item-box">
        <div>名称</div>
        <div>报价咨询服务包</div>
    </div>
    <div class="item-box">
        <div>价格</div>
        <div>18888元</div>
    </div>
    <div class="item-box">
        <div>数量</div>
        <div>1个</div>
    </div>
    <div class="item-box">
        <div>手机号</div>
        <input class="phone" type="number" placeholder="请输入手机号" />
    </div>
    <div class="item-box">
        <div>短信验证码</div>
        <div class="v-code-box">
            <input class="phone" type="number" placeholder="请输入短信验证码" />
            <div class="v-code-btn">获取验证码</div>
        </div>
    </div>
    <div class="item-box">
        <div>需付</div>
        <div class="price">18888元</div>
    </div>
    <div class="bottom-btns">
        <div></div>
        <div class="wechat-btn">微信支付</div>
    </div>
</div>
</template>

<script>
export default {
    methods: {
        goback() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.title-box {
    width: 100vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #F0F0F0;
}
.back-btn {
    width: 140px;
    padding: 20px;
    color: #666;
}
.blank-div {
    width: 100px;
}
.title {
    height: 66px;
    line-height: 66px;
    font-size: 26px;
    color: #333333;
    font-weight: bold;
}
.item-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 20px;
    line-height: 66px;
    font-size: 18px;
    color: #333333;
    border-bottom: 1px solid #F0F0F0;
}
.price {
    color: #FF580C;
    font-weight: bold;
}
input {
    padding: 10px;
    border: 1px solid #F0F0F0;
    border-radius: 10px;
}
.phone {
    height: 40px;
}
.v-code-box {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.bottom-btns {
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.v-code-btn {
    width: 150px;
    height: 40px;
    margin-left: 10px;
    line-height: 40px;
    border-radius: 5px;
    font-size: 14px;
    color: white;
    text-align: center;
    background-color: #07c160;
}
.wechat-btn {
    width: 200px;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    color: white;
    text-align: center;
    background-color: #07c160;
}
</style>

